import { render, staticRenderFns } from "./fileImage.vue?vue&type=template&id=493ce1df"
import script from "./fileImage.vue?vue&type=script&lang=js"
export * from "./fileImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/deduct_saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('493ce1df')) {
      api.createRecord('493ce1df', component.options)
    } else {
      api.reload('493ce1df', component.options)
    }
    module.hot.accept("./fileImage.vue?vue&type=template&id=493ce1df", function () {
      api.rerender('493ce1df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fileImage.vue"
export default component.exports